import { topicsSlice } from './slice';

export const { actions, reducer } = topicsSlice;
export { selectors } from './adapter';
export * as thunks from './thunks';
export * from './types';
